import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import {enToFa} from '../utils/NumberUtility';
import {yesNo} from '../utils/BooleanUtility';
import {Collapse} from 'reactstrap';
import PerfectScrollbar from 'react-perfect-scrollbar';
import Loading from '../components/Loading';
import Numeral from 'numeral';
import VehicleAdItem from '../components/VehicleAdItem';
import Pagination from '../components/Pagination';
import {startFetchAlarmAds, startFetchAlarmDetails} from '../actions/alarms';
import {nextPage, prevPage} from '../actions/alarmDetailFilters';

const GalleryDetails = (props) => {

    const [isAdsLoading, setAdsLoading] = useState(true);
    const [isInfoLoading, setInfoLoading] = useState(true);
    const [isOpen, setOpen] = useState(false);

    useEffect(() => {
        if (isAdsLoading){
            props.startFetchAlarmAds(props.match.params.id)
            .then(({success, error}) => {
                if (success){
                    setAdsLoading(false)
                }
                else{
                    setAdsLoading(false)
                }
            })
        }
    }, [isAdsLoading])

    useEffect(() => {
        if (isInfoLoading){
            props.startFetchAlarmDetails(props.match.params.id)
            .then(({success, error}) => {
                if (success){
                    setInfoLoading(false)
                }
                else{
                    setInfoLoading(false)
                }
            })
        }
    }, [])

    const handleNext = () => {
        props.nextPage();
        setAdsLoading(true);
    }
    
    const handlePrev = () => {
        props.prevPage();
        setAdsLoading(true);
    }

    const onExpandClicked = (e) => {
        setOpen(!isOpen);
    }
    
    return(
        <div className="container-sm optimized__d-flex-class flex-column h-100 px-0 ads">
        {
            (isAdsLoading || isInfoLoading) ? (
                <Loading/>
            ) : (
                <>
                    <Collapse isOpen={isOpen}>
                        <div className="ads__drop-bg">
                            <span className="vehicle-details__table-key col-6">برند</span>
                            <span className="vehicle-details__table-value col-6">{enToFa(props.info.targetVehicle.brand.name)}</span>
                            <span className="vehicle-details__table-key col-6">کاربری</span>
                            <span className="vehicle-details__table-value col-6">{enToFa(props.info.targetVehicle.category.name)}</span>
                            <span className="vehicle-details__table-key col-6">تیپ</span>
                            <span className="vehicle-details__table-value col-6">{enToFa(props.info.targetVehicle.name)}</span>
                            <span className="vehicle-details__table-key col-6">از سال</span>
                            <span className="vehicle-details__table-value col-6">{enToFa(props.info.fromYear)}</span>
                            <span className="vehicle-details__table-key col-6">تا سال</span>
                            <span className="vehicle-details__table-value col-6">{enToFa(props.info.toYear)}</span>
                            <span className="vehicle-details__table-key col-6">از قیمت</span>
                            <span className="vehicle-details__table-value col-6">{enToFa(`${Numeral(props.info.fromPrice).format('0,0')} تومان`)}</span>
                            <span className="vehicle-details__table-key col-6">تا قیمت</span>
                            <span className="vehicle-details__table-value col-6">{enToFa(`${Numeral(props.info.toPrice).format('0,0')} تومان`)}</span>
                        </div>
                    </Collapse>
                    <div className="ads__drop-handle pr-4">
                        <span onClick={onExpandClicked}><i class="material-icons p-2">{isOpen ? "keyboard_arrow_up" : "keyboard_arrow_down"}</i></span>
                        <span>اطلاعات گوش به زنگ</span>
                    </div>
                    {/* <PerfectScrollbar id="vehicle-scroller" className="px-4"> */}
                        {
                            props.ads.map(el => (<VehicleAdItem for="vehicle-scroller" key={el.id} info={el} push={props.history.push}/>))
                        }
                        <Pagination
                            currentPage={props.page}
                            pageCount={props.pageCount}
                            handleNext={handleNext}
                            handlePrev={handlePrev}
                        />
                    {/* </PerfectScrollbar> */}
                </>
            )
        }
        </div>
    );
}

const mapStateToProps = (state, props) => ({
    page: state.alarmDetailFilters.page,
    pageCount: Math.ceil(state.alarmDetailInfo.total / state.alarmDetailFilters.page_size),
    ads: state.alarmDetailInfo.items,
    info: state.alarmDetailInfo.info
});

const mapDispatchToProps = (dispatch) => ({
    nextPage: () => dispatch(nextPage()),
    prevPage: () => dispatch(prevPage()),
    startFetchAlarmAds: (ident) => dispatch(startFetchAlarmAds(ident)),
    startFetchAlarmDetails: (ident) => dispatch(startFetchAlarmDetails(ident))
});

export default connect(mapStateToProps, mapDispatchToProps)(GalleryDetails);